import { closeModal } from "action/modal/closeModal";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Price from "modules/components/prices/price/Price";
import WasPrice from "modules/components/prices/was-price/WasPrice";
import CardActions from "modules/components/product-cards/__components__/card-actions/CardActions";
import ProductThumbnail from "modules/components/product-cards/__components__/product-thumbnail/ProductThumbnail";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import HideIf from "util/HideIf";
import { getProductHeading } from "util/product/get-product-heading";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import styles from "./manufacturer.module.scss";

function ProductSliderCard(props: any) {
  const {
    product, sideBarHandler, badge, showAddToCart = true,
  } = props;
  const { t } = useTranslation("product");
  const dispatch = useDispatch();
  const router = useRouter();

  function handleCardClick() {
    if (sideBarHandler) {
      sideBarHandler({
        product,
        title: t("View Product Details"),
      });
    } else {
      const { href, asPath } = getHrefAndPath({ asPath: product.canonicalUrl });
      router.push(href, asPath);
      dispatch(closeModal());
    }
  }

  return (
    <div onClick={handleCardClick}>
      <div className={styles.product_item}>
        <CardActions product={product} showAddToCart={showAddToCart} />
        <div className={styles.product_item_image_container}>
          <HideIf show={badge}>
            <PAText className={styles.discount_badge} fontSize={FONT_SIZE[0]} bold color="white">{badge}</PAText>
          </HideIf>
          <ProductThumbnail product={product} size={150} />
        </div>

        <div className={styles.product_item_description}>
          <PAText
            inlineBlock
            className={styles.product_item_title}
            color="black"
            bold
            title={getProductHeading(product)}
          >
            {getProductHeading(product)}

          </PAText>

          <div className={styles.product_price_container}>
            <Price product={product} className={styles.product_price_range} sameSize />
            <HideIf show={product.wasPrice}>
              <WasPrice product={product} />
            </HideIf>
          </div>
        </div>
      </div>

    </div>
  );
}

export default ProductSliderCard;
